import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=77d8da2c&"
import script from "./ChatMessages.vue?vue&type=script&lang=ts&"
export * from "./ChatMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports